/**
 * Analytics — Admin Health API Contracts
 *
 * Wire format for AdminHealthController (GET /api/v1/admin/health).
 */

import { z } from 'zod';

export const ServiceHealthStatusSchema = z.enum(['healthy', 'degraded', 'unhealthy', 'unknown']);

export type ServiceHealthStatus = z.infer<typeof ServiceHealthStatusSchema>;

export const ServiceHealthCheckSchema = z.record(
  z.object({ status: z.string() }).catchall(z.unknown()),
);

export const ServiceHealthResultSchema = z.object({
  name: z.string(),
  status: ServiceHealthStatusSchema,
  responseTimeMs: z.number().nullable(),
  uptime: z.number().nullable(),
  version: z.string().nullable(),
  checks: ServiceHealthCheckSchema,
  lastCheckedAt: z.string(),
  error: z.string().nullable(),
});
export type ServiceHealthResult = z.infer<typeof ServiceHealthResultSchema>;

export const AggregatedHealthResponseSchema = z.object({
  overallStatus: z.enum(['healthy', 'degraded', 'unhealthy']),
  checkedAt: z.string(),
  services: z.array(ServiceHealthResultSchema),
  summary: z.object({
    total: z.number().int(),
    healthy: z.number().int(),
    degraded: z.number().int(),
    unhealthy: z.number().int(),
    unknown: z.number().int(),
  }),
});
export type AggregatedHealthResponse = z.infer<typeof AggregatedHealthResponseSchema>;
